import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './Style.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';

type OneToTenSliderProps = {
  questionid: string;
  questionTitle: string;
  modalText?: string;
  onOpenModal?: (html?: unknown) => void;
  onSetValue: (value: { id: string; value: string }) => void;
  assessmentValues: Record<string, unknown>;
  textValues: string[];
  width: string;
};

export function OneToTenSlider({
  questionid,
  questionTitle,
  modalText,
  onOpenModal,
  onSetValue,
  assessmentValues,
  textValues,
  width,
}: OneToTenSliderProps) {
  const [textValue, setTextValue] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (assessmentValues[questionid]) {
      setTextValue(assessmentValues[questionid].toString());
    } else {
      setTextValue('5');
      onSetValue({ id: questionid, value: '5' });
    }
    // Init from the saved value once, the widget is the source of truth after
    // mount and pushes every change up itself.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRangeChange = (event) => {
    const { value } = event.target;
    setTextValue(value);
    onSetValue({ id: questionid, value });
  };

  return (
    <div className={`req question_block${width}`}>
      <fieldset id={questionid} data-input-type="one-to-ten-slider">
        <legend className="assessment_question_title">{questionTitle}</legend>
        {modalText && (
          <ModalTrigger
            modalText={modalText}
            onOpenModal={onOpenModal}
            question={questionid}
            questionTitle={questionTitle}
          />
        )}
        <div className="answer_block fs-exclude">
          <div
            className="painSlider pain_slider scale-10"
            id={`${questionid}-ten-pain-slider-container`}
          >
            <div className="leftLabel">{textValues[0]}</div>
            <div className="rightLabel">{textValues[1]}</div>
            <div className={`range-container value-${textValue}`}>
              <input
                type="range"
                min="1"
                max="10"
                value={textValue}
                onChange={handleRangeChange}
                id={`${questionid}_slider`}
                aria-valuetext={textValue}
                data-uw-ignore-s3
              />
            </div>
            <label
              htmlFor={`${questionid}_slider`}
              className="valueHandle"
              id={`${questionid}_value_handle`}
              aria-label={`${questionTitle} ${t('slider.description.from')} ${textValues[0]} ${t('slider.description.to')} ${textValues[1]}`}
            >
              {textValue}
            </label>
          </div>
        </div>
      </fieldset>
    </div>
  );
}
